module.exports = __webpack_public_path__ + "src/img/rotateRight.791b52a8.svg";